/* RESPONSIBLE TEAM: team-ai-agent */
import StepSerializer from '../step';

export default StepSerializer;
